import { LS_KEYS } from "@core/core.constants";

export const isMswEnabled = () => {
  // TODO remove this condition when Mint demo is over
  if (import.meta.env?.MODE === "preprod" && window.tenant === "kuriosity") {
    return true;
  }
  return import.meta.env?.VITE_APP_USE_MSW
    ? import.meta.env.VITE_APP_USE_MSW === "true"
    : window?.localStorage?.getItem(LS_KEYS.MSW) === "true";
};

/**
 * The worker scope is `${prefix}/`, so the bare prefix (`/ecms`) is out of scope
 * and nothing gets intercepted. Redirect to `${prefix}/`.
 *
 * @returns `true` when a redirect was triggered (the page is about to reload).
 */
export const redirectToWorkerScope = () => {
  const prefix = import.meta.env.VITE_APP_FRONT_URL_PREFIX;

  if (!prefix || window.location.pathname !== prefix) {
    return false;
  }

  window.location.replace(
    `${prefix}/${window.location.search}${window.location.hash}`,
  );

  return true;
};
